"use client";

import { getPillsForSport } from "@/lib/conditions/location-pills";
import type { LocationPillData } from "@/lib/conditions/location-pills";
import { resolveSlotSport } from "@/lib/conditions/sport-aware-slot";
import { useShallowSearchParam } from "@/lib/hooks/use-shallow-search-param";

type LocationDescriptionProps = {
  defaultSport: string;
  availableSports: string[];
  data: LocationPillData;
};

function Pill({ label, value }: { label: string; value: string }) {
  return (
    <div className="flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-navy/[0.04] border border-border-light text-[12px]">
      <span className="text-text-muted">{label}:</span>
      <span className="font-medium text-navy">{value}</span>
    </div>
  );
}

export function LocationDescription({
  defaultSport,
  availableSports,
  data,
}: LocationDescriptionProps) {
  // Sport comes from the URL after hydration; the server renders the
  // default sport's pills so the static HTML stays complete
  const sportParam = useShallowSearchParam("sport");
  const urlSport = sportParam ?? defaultSport;
  const activeSport = resolveSlotSport(urlSport, defaultSport, availableSports);
  const pills = getPillsForSport(activeSport, data);

  if (pills.length === 0) return null;

  return (
    <section className="py-4">
      <div className="flex flex-wrap gap-2">
        {pills.map((pill) => (
          <Pill key={pill.label} label={pill.label} value={pill.value} />
        ))}
      </div>
    </section>
  );
}
